// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"54edb687","308":"b1b6385f","450":"85defeb3","491":"b4b1637a"}[chunkId] + ".chunk.css";
};